import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuard } from './guards/auth-guard.service';
import { RoleGuard } from './guards/role-guard.service';
import { TokenInterceptor } from './interceptors/token-interceptor';
import { ErrorInterceptor } from './interceptors/error-interceptor';
import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { ConfirmationService, MessageService } from 'primeng/api/';
import {
  ApiService,
  AuthService,
  TokenService,
  LoaderService,
  EncryptionService,
  ToastService,
  FileService,
  CommonService,
  UserService,
  RestaurantService,
  OutletService,
  TableService,
  CouponService,
  EventService,
  OrderService,
  MenuService,
  TaxService,
  FeeService,
  TipService,
  RewardService,
  DeliveryService,
  PaymentService,
  FeatureService,
  DashboardService,
  MasterService,
  NotificationService,
  GiftcardService,
  BannerService,
  GalleryService,
  ReportService,
  ExcelService,
  ExportService,
  KitchenService,
  SearchService,
  HeaderService,
  DiagnosticService,
  ShipDayService,
} from './services';
@NgModule({
  imports: [CommonModule],

  providers: [
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    AuthGuard,
    RoleGuard,
    TokenService,
    ApiService,
    AuthService,
    ToastService,
    EncryptionService,
    ConfirmationService,
    MessageService,
    FileService,
    CommonService,
    RestaurantService,
    OutletService,
    UserService,
    TableService,
    CouponService,
    EventService,
    OrderService,
    MenuService,
    TaxService,
    FeeService,
    TipService,
    RewardService,
    DeliveryService,
    PaymentService,
    FeatureService,
    DashboardService,
    MasterService,
    NotificationService,
    GiftcardService,
    BannerService,
    GalleryService,
    ReportService,
    ExcelService,
    ExportService,
    KitchenService,
    SearchService,
    HeaderService,
    DiagnosticService,
    ShipDayService,
  ],
})
export class CoreModule {}
